export default __webpack_public_path__ + "static/media/ziyuan.68fd1b2a.png";